import { useState } from 'react';
import { createPedido } from '../../services/pedidoService';
import { IPedido } from '../../interfaces/pedido.interface';

const useCreatePedido = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (pedido: IPedido): Promise<string | null> => {
        setLoading(true);
        try {
            const response: any = await createPedido(pedido);
            const newPedidoId = response.pedido; // Captura o ID diretamente da resposta
            return newPedidoId; // Retorna o ID imediatamente após a criação
        } catch (err) {
            console.error(err); // Registrar o erro no console para depuração
            setError('Falha ao criar pedido');
            return null; // Retorna null em caso de erro
        } finally {
            setLoading(false);
        }
    };

    return { createPedido: create, loading, error };
};

export default useCreatePedido;
